import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { digitsRegex, thousandsSeparatingRegex } from '../plus-minus-input/plus-minus-input.component';

@Component({
  selector: 'libero-money-amount-input',
  templateUrl: './money-amount-input.component.html',
  styleUrls: ['./money-amount-input.component.scss'],
  standalone: false
})
export class MoneyAmountInputComponent {
  @Input({ required: true }) public formName!: AbstractControl;
  @Input({ required: true }) public currency!: string;
  @Input() public min?: number;
  @Input() public max?: number;
  @Input() public invalidText?: { min: string, max: string };

  public currentInputValue = '0';

  private get currValueNumber(): number {
    return parseInt(this.currentInputValue.replaceAll(' ', ''));
  }

  public invalidInput(): boolean {
    const value = this.currValueNumber;

    if(!(this.formName.touched || this.formName.dirty)) {
      return false;
    }

    if(value === 0 || this.currentInputValue === '') {
      return true;
    }

    return this.underMin || this.aboveMax;
  }

  public get underMin(): boolean {
    if(this.min && this.currValueNumber < this.min) {
      return true;
    }
    return false;
  }

  public get aboveMax(): boolean {
    if(this.max && this.currValueNumber >= this.max) {
      return true;
    }
    return false;
  }

  public inputUpdated(): void {
    this.currentInputValue = this.transformForView(this.currentInputValue);
    this.formName.patchValue(this.currentInputValue);
    this.formName.markAsTouched();
    this.formName.markAsDirty();
  }

  private transformForView(newValue: string): string {
    const onlyNumbersValue = newValue.toString().replaceAll(digitsRegex, '').replaceAll(' ', '');
    const thousandsSpaceSeparated = onlyNumbersValue.replace(thousandsSeparatingRegex, ' ');

    if(thousandsSpaceSeparated.charAt(0) === '0') {
      //remove leading zero
      return  thousandsSpaceSeparated.substring(1);
    }

    return thousandsSpaceSeparated;
  }
}
